/* Якість дзвінків, KPI колл-центру і маршрутизація відгуків (/call-quality, /call-kpi, docs/processes C4). Kept apart from uk.ts/en.ts to keep merges small. */
export const callqualityUk = {
  'nav.callQuality': 'Якість дзвінків',
  'nav.callKpi': 'KPI колл-центру',
  'perm.callquality.own': 'Якість дзвінків: мої оцінки за критеріями клініки',
  'perm.callquality.read': 'Якість дзвінків: оцінки всіх операторів, калібрування, KPI колл-центру, відгуки клієнтів',
  'perm.callquality.manage': 'Якість дзвінків: критерії й ваги, експорт в AI SIP, калібрування оцінок, маршрутизація відгуків',
  'callquality.title': 'Якість дзвінків',
  'callquality.subtitle': 'Оцінки дзвінків AI SIP за критеріями клініки, рейтинг операторів, калібрування і відгуки клієнтів',
  'callquality.tab.operators': 'Оператори',
  'callquality.tab.calls': 'Дзвінки',
  'callquality.tab.calibration': 'Калібрування',
  'callquality.tab.criteria': 'Критерії',
  'callquality.tab.reviews': 'Відгуки',
  'callquality.avg': 'Середня оцінка',
  'callquality.callsN': 'дзвінків: {n}',
  'callquality.operators': 'Операторів',
  'callquality.criticalCalls': 'Критичних помилок',
  'callquality.weakestClinic': 'Найслабший критерій',
  'callquality.leaderboard': 'Рейтинг операторів',
  'callquality.myScores': 'Мої оцінки',
  'callquality.trend': 'Динаміка оцінки',
  'callquality.granularity': 'Групування',
  'callquality.byWeek': 'По тижнях',
  'callquality.byMonth': 'По місяцях',
  'callquality.clinic': 'Клініка',
  'callquality.scoredOf': '{n} з {m} оцінено',
  'callquality.criticalN': 'критичних: {n}',
  'callquality.calibratedN': 'відкалібровано: {n}',
  'callquality.critical': 'Критична помилка',
  'callquality.criticalHint': 'Не виконано критичний критерій (мова, заборонені дії)',
  'callquality.criticalShort': 'критичний',
  'callquality.criticalOnly': 'Лише критичні',
  'callquality.notLinked': 'Ваш обліковий запис не пов\'язаний з оператором AI SIP',
  'callquality.notLinkedHint': 'Попросіть адміністратора зіставити вас з оператором у «Адміністрування → Оператори», і тут з\'являться ваші оцінки.',
  'callquality.noScores': 'Оцінених дзвінків за період немає',
  'callquality.noScoresHint': 'Оцінки з\'являються, коли AI SIP проаналізує дзвінки за інструкцією з критеріями клініки. Надішліть критерії в AI SIP на вкладці «Критерії» і активуйте інструкцію.',
  'callquality.noCalls': 'Дзвінків за цими фільтрами немає',
  'callquality.operator': 'Оператор',
  'callquality.allOperators': 'Усі оператори',
  'callquality.score': 'Оцінка',
  'callquality.failed': 'Не виконано',
  'callquality.failedCriterion': 'Невиконаний критерій',
  'callquality.anyCriterion': 'Будь-який критерій',
  'callquality.calibratedMark': 'відкалібровано',
  'callquality.duration': 'Тривалість',
  'callquality.summary': 'Підсумок AI',
  'callquality.when': 'Коли',
  'callquality.criterion': 'Критерій',
  'callquality.ai': 'AI',
  'callquality.manager': 'Керівник',
  'callquality.delta': 'Різниця',
  'callquality.comment': 'Коментар',
  'callquality.by': 'Хто',
  'callquality.agreement': 'Згода керівників з AI',
  'callquality.agreementLine': 'згода {a} · різниця {d} · {n}',
  'callquality.noCalibrations': 'Калібрувань за період немає',
  'callquality.noCalibrationsHint': 'Відкрийте дзвінок, прослухайте його і змініть оцінку критерію з коментарем — вона з\'явиться тут, а оцінка оператора перерахується.',
  'callquality.scorecard': 'Оцінка дзвінка',
  'callquality.fromAISIP': 'Оцінка з аналізу AI SIP',
  'callquality.noAnalysis': 'Аналізу AI SIP немає — оцінка лише з калібрувань',
  'callquality.openCall': 'Відкрити дзвінок',
  'callquality.direction': 'Напрямок',
  'callquality.dir.inbound': 'Вхідний',
  'callquality.dir.outbound': 'Вихідний',
  'callquality.criteria': 'Критерії',
  'callquality.info': 'довідково',
  'callquality.notEvaluated': 'не оцінено',
  'callquality.calibrateX': 'Калібрувати «{name}»',
  'callquality.overrideBy': '{who} змінив оцінку (AI: {ai})',
  'callquality.revert': 'Повернути AI',
  'callquality.suggestions': 'Поради AI',
  'callquality.excerpt': 'Початок розмови',
  'callquality.noExcerpt': 'Транскрипту немає',
  'callquality.role.operator': 'Оператор',
  'callquality.role.client': 'Клієнт',
  'callquality.role.other': 'Інший',
  'callquality.history': 'Історія калібрувань',
  'callquality.notApplicable': 'не застосовно',
  'callquality.calibrateTitle': 'Калібрування оцінки',
  'callquality.aiScore': 'AI: {v} ({p})',
  'callquality.managerScore': 'Оцінка керівника',
  'callquality.calibrateComment': 'Чому змінюєте оцінку',
  'callquality.pass': 'Виконано',
  'callquality.fail': 'Не виконано',
  'callquality.saved': 'Критерій збережено',
  'callquality.calibrated': 'Оцінку змінено',
  'callquality.reverted': 'Повернуто оцінку AI',
  'callquality.published': 'Критерії надіслано в AI SIP як чернетку',
  'callquality.routed': 'Відгук направлено',
  // criteria
  'callquality.crit.add': 'Критерій',
  'callquality.crit.seed': 'Додати типові',
  'callquality.crit.seeded': 'Типові критерії додано',
  'callquality.crit.showInactive': 'Показати вимкнені',
  'callquality.crit.title': 'Назва',
  'callquality.crit.kind': 'Тип',
  'callquality.crit.kind.scored': 'Бали',
  'callquality.crit.kind.flag': 'Так / ні',
  'callquality.crit.scale': 'Шкала',
  'callquality.crit.weight': 'Вага',
  'callquality.crit.status': 'Статус',
  'callquality.crit.toConfirm': 'уточнити',
  'callquality.crit.inactive': 'вимкнено',
  'callquality.crit.empty': 'Критеріїв ще немає',
  'callquality.crit.emptyHint': 'Натисніть «Додати типові», щоб створити критерії з журналу якості колл-центру (привітання, мова, виявлення потреби, запис, підсумок, заборонені дії…), і відредагуйте їх ваги.',
  'callquality.crit.edit': 'Критерій оцінки дзвінка',
  'callquality.crit.key': 'Ключ (латиницею)',
  'callquality.crit.titleHint': 'Під цією назвою критерій з\'явиться в інструкції AI SIP',
  'callquality.crit.description': 'Що перевіряти',
  'callquality.crit.min': 'Мінімум',
  'callquality.crit.max': 'Максимум',
  'callquality.crit.weightHint': '0 — довідковий критерій, не входить в оцінку',
  'callquality.crit.values': 'Можливі значення (через кому)',
  'callquality.crit.goodValue': 'Значення, яке зараховується',
  'callquality.crit.condition': 'Оцінювати лише якщо',
  'callquality.crit.aisipNames': 'Інші назви в аналізах AI SIP (через кому)',
  'callquality.crit.criticalLabel': 'Невиконання — критична помилка дзвінка',
  'callquality.crit.active': 'Діє',
  'callquality.crit.confirmed': 'Підтверджено власником',
  'callquality.ins.title': 'Інструкція AI SIP',
  'callquality.ins.hint': 'Критерії клініки передаються в AI SIP як нова чернетка інструкції аналізу. Bridge не публікує і не активує її: перевірте чернетку тестами в AI SIP, опублікуйте й активуйте там.',
  'callquality.ins.publish': 'Надіслати в AI SIP',
  'callquality.ins.publishTitle': 'Створити чернетку інструкції в AI SIP?',
  'callquality.ins.publishDesc': 'Потрібен токен READ_WRITE у конекторі AI SIP. Чинна інструкція не зміниться, доки ви не активуєте чернетку.',
  'callquality.ins.json': 'JSON для імпорту',
  'callquality.ins.markdown': 'Текст для ручного введення',
  'callquality.ins.standalone': 'Без поточної інструкції AI SIP',
  'callquality.ins.history': 'Останні експорти',
  'callquality.ins.none': 'Критерії ще не передавались в AI SIP',
  'callquality.ins.mode.import': 'чернетка в AI SIP',
  'callquality.ins.mode.document': 'завантажено файл',
  'callquality.ins.failed': 'помилка',
  // reviews
  'callquality.route.complaint': 'Скарга (інцидент)',
  'callquality.route.followup': 'Дзвінок-уточнення',
  'callquality.route.publish': 'Прохання про відгук',
  'callquality.route.none': 'Без дій',
  'callquality.route.unrouted': 'Не розподілено',
  'callquality.rev.rules': 'Оцінка до {c} — скарга, до {f} — дзвінок-уточнення, від {p} — прохання залишити відгук у Google чи Instagram (без автопублікації).',
  'callquality.rev.rulesNoPublish': 'Оцінка до {c} — скарга, до {f} — дзвінок-уточнення; прохання про публічний відгук вимкнено.',
  'callquality.rev.auto': 'Нові оцінки розподіляються автоматично',
  'callquality.rev.manual': 'Автоматичний розподіл вимкнено — розподіляйте вручну',
  'callquality.rev.run': 'Розподілити нові',
  'callquality.rev.ran': 'Розподілено: скарг {c}, уточнень {f}, прохань {p}',
  'callquality.rev.status': 'Статус',
  'callquality.rev.status.todo': 'До роботи',
  'callquality.rev.status.unrouted': 'Не розподілені',
  'callquality.rev.status.open': 'У роботі',
  'callquality.rev.status.done': 'Виконані',
  'callquality.rev.status.dismissed': 'Відхилені',
  'callquality.rev.status.all': 'Усі',
  'callquality.rev.anyRoute': 'Будь-який маршрут',
  'callquality.rev.col.at': 'Коли',
  'callquality.rev.col.score': 'Оцінка',
  'callquality.rev.col.client': 'Клієнт і лікар',
  'callquality.rev.col.comment': 'Відгук',
  'callquality.rev.col.route': 'Маршрут',
  'callquality.rev.suggested': 'пропонується: {r}',
  'callquality.rev.incident': 'Інцидент №{n}',
  'callquality.rev.inquiry': 'Звернення №{n}',
  'callquality.rev.task': 'Задача: {s}',
  'callquality.rev.routeBtn': 'Направити',
  'callquality.rev.done': 'Виконано',
  'callquality.rev.dismiss': 'Відхилити',
  'callquality.rev.closed': 'Відгук закрито',
  'callquality.rev.routeTitle': 'Куди направити відгук',
  'callquality.rev.note': 'Примітка',
  'callquality.rev.empty': 'Відгуків до роботи немає',
  'callquality.rev.emptyHint': 'Оцінки візитів із застосунку, бота й кіоску з\'являються тут. Низькі стають скаргою або дзвінком-уточненням, високі — проханням залишити публічний відгук.',
  'callquality.rev.source.app': 'застосунок',
  'callquality.rev.source.bot': 'бот',
  'callquality.rev.source.kiosk': 'кіоск',
  // KPI
  'callquality.kpi.title': 'KPI колл-центру',
  'callquality.kpi.subtitle': 'Дзвінки, відповідь, конверсія в запис, передзвони в межах SLA, звернення за каналами і задоволеність клієнтів',
  'callquality.kpi.inbound': 'Вхідні',
  'callquality.kpi.outbound': 'Вихідні',
  'callquality.kpi.answered': 'Прийняті',
  'callquality.kpi.missed': 'Пропущені',
  'callquality.kpi.answerRate': 'Прийнято дзвінків',
  'callquality.kpi.avgWait': 'Очікування відповіді',
  'callquality.kpi.avgHandle': 'Тривалість розмови',
  'callquality.kpi.fcr': 'Вирішено з першого дзвінка',
  'callquality.kpi.fcrSub': 'повторних за 24 год: {v}',
  'callquality.kpi.conversion': 'Дзвінок → запис',
  'callquality.kpi.bookedN': 'записів: {n}',
  'callquality.kpi.callback': 'Передзвонили вчасно',
  'callquality.kpi.callbackSub': '{n} з {m} пропущених',
  'callquality.kpi.breaches': 'Порушень SLA',
  'callquality.kpi.breachesSub': 'з {n} звернень',
  'callquality.kpi.csat': 'Оцінка клієнтів',
  'callquality.kpi.csatSub': '{n} оцінок · 4–5: {p}',
  'callquality.kpi.quality': 'Якість дзвінків',
  'callquality.kpi.byDay': 'Дзвінки по днях',
  'callquality.kpi.byHour': 'Вхідні по годинах',
  'callquality.kpi.channels': 'Звернення за каналами',
  'callquality.kpi.col.channel': 'Канал',
  'callquality.kpi.col.total': 'Усього',
  'callquality.kpi.col.open': 'Відкриті',
  'callquality.kpi.col.booked': 'Записано',
  'callquality.kpi.col.lost': 'Втрачено',
  'callquality.kpi.col.breaches': 'Порушення SLA',
  'callquality.kpi.byOperator': 'Оператори',
  'callquality.kpi.col.answered': 'Розмов',
  'callquality.kpi.col.talk': 'Час розмов',
  'callquality.kpi.col.avg': 'Середня',
  'callquality.kpi.col.conversion': 'Конверсія',
  'callquality.kpi.col.quality': 'Якість',
  'callquality.kpi.empty': 'Дзвінків за період немає',
  'callquality.kpi.emptyHint': 'Дзвінки приходять з AI SIP. Перевірте конектор AI SIP в «Адміністрування → Конектори» або оберіть інший період.',
}

export const callqualityEn: Partial<Record<keyof typeof callqualityUk, string>> = {
  'nav.callQuality': 'Call quality',
  'nav.callKpi': 'Call-centre KPI',
  'perm.callquality.own': 'Call quality: my scores against the clinic criteria',
  'perm.callquality.read': 'Call quality: every operator\'s scores, calibrations, call-centre KPI, client reviews',
  'perm.callquality.manage': 'Call quality: criteria and weights, AI SIP export, calibration, review routing',
  'callquality.title': 'Call quality',
  'callquality.subtitle': 'AI SIP call scores against the clinic criteria, operator leaderboard, calibration and client reviews',
  'callquality.tab.operators': 'Operators',
  'callquality.tab.calls': 'Calls',
  'callquality.tab.calibration': 'Calibration',
  'callquality.tab.criteria': 'Criteria',
  'callquality.tab.reviews': 'Reviews',
  'callquality.avg': 'Average score',
  'callquality.callsN': 'calls: {n}',
  'callquality.operators': 'Operators',
  'callquality.criticalCalls': 'Critical errors',
  'callquality.weakestClinic': 'Weakest criterion',
  'callquality.leaderboard': 'Operator leaderboard',
  'callquality.myScores': 'My scores',
  'callquality.trend': 'Score trend',
  'callquality.granularity': 'Grouping',
  'callquality.byWeek': 'By week',
  'callquality.byMonth': 'By month',
  'callquality.clinic': 'Clinic',
  'callquality.scoredOf': '{n} of {m} scored',
  'callquality.criticalN': 'critical: {n}',
  'callquality.calibratedN': 'calibrated: {n}',
  'callquality.critical': 'Critical error',
  'callquality.criticalHint': 'A critical criterion failed (language, prohibited actions)',
  'callquality.criticalShort': 'critical',
  'callquality.criticalOnly': 'Critical only',
  'callquality.notLinked': 'Your account is not linked to an AI SIP operator',
  'callquality.notLinkedHint': 'Ask an admin to map you to an operator in «Admin → Operators» and your scores will appear here.',
  'callquality.noScores': 'No scored calls in the period',
  'callquality.noScoresHint': 'Scores appear once AI SIP analyses calls with the instruction holding the clinic criteria. Send the criteria to AI SIP on the «Criteria» tab and activate the instruction.',
  'callquality.noCalls': 'No calls for these filters',
  'callquality.operator': 'Operator',
  'callquality.allOperators': 'All operators',
  'callquality.score': 'Score',
  'callquality.failed': 'Failed',
  'callquality.failedCriterion': 'Failed criterion',
  'callquality.anyCriterion': 'Any criterion',
  'callquality.calibratedMark': 'calibrated',
  'callquality.duration': 'Duration',
  'callquality.summary': 'AI summary',
  'callquality.when': 'When',
  'callquality.criterion': 'Criterion',
  'callquality.ai': 'AI',
  'callquality.manager': 'Manager',
  'callquality.delta': 'Difference',
  'callquality.comment': 'Comment',
  'callquality.by': 'By',
  'callquality.agreement': 'Manager agreement with AI',
  'callquality.agreementLine': 'agreement {a} · difference {d} · {n}',
  'callquality.noCalibrations': 'No calibrations in the period',
  'callquality.noCalibrationsHint': 'Open a call, listen to it and change a criterion score with a comment — it shows up here and the operator score is recalculated.',
  'callquality.scorecard': 'Call scorecard',
  'callquality.fromAISIP': 'Score from the AI SIP analysis',
  'callquality.noAnalysis': 'No AI SIP analysis — score from calibrations only',
  'callquality.openCall': 'Open call',
  'callquality.direction': 'Direction',
  'callquality.dir.inbound': 'Inbound',
  'callquality.dir.outbound': 'Outbound',
  'callquality.criteria': 'Criteria',
  'callquality.info': 'informational',
  'callquality.notEvaluated': 'not evaluated',
  'callquality.calibrateX': 'Calibrate «{name}»',
  'callquality.overrideBy': '{who} changed the score (AI: {ai})',
  'callquality.revert': 'Back to AI',
  'callquality.suggestions': 'AI suggestions',
  'callquality.excerpt': 'Start of the conversation',
  'callquality.noExcerpt': 'No transcript',
  'callquality.role.operator': 'Operator',
  'callquality.role.client': 'Client',
  'callquality.role.other': 'Other',
  'callquality.history': 'Calibration history',
  'callquality.notApplicable': 'not applicable',
  'callquality.calibrateTitle': 'Calibrate score',
  'callquality.aiScore': 'AI: {v} ({p})',
  'callquality.managerScore': 'Manager score',
  'callquality.calibrateComment': 'Why you change the score',
  'callquality.pass': 'Passed',
  'callquality.fail': 'Failed',
  'callquality.saved': 'Criterion saved',
  'callquality.calibrated': 'Score changed',
  'callquality.reverted': 'AI score restored',
  'callquality.published': 'Criteria sent to AI SIP as a draft',
  'callquality.routed': 'Review routed',
  'callquality.crit.add': 'Criterion',
  'callquality.crit.seed': 'Add defaults',
  'callquality.crit.seeded': 'Default criteria added',
  'callquality.crit.showInactive': 'Show disabled',
  'callquality.crit.title': 'Name',
  'callquality.crit.kind': 'Type',
  'callquality.crit.kind.scored': 'Points',
  'callquality.crit.kind.flag': 'Yes / no',
  'callquality.crit.scale': 'Scale',
  'callquality.crit.weight': 'Weight',
  'callquality.crit.status': 'Status',
  'callquality.crit.toConfirm': 'to confirm',
  'callquality.crit.inactive': 'disabled',
  'callquality.crit.empty': 'No criteria yet',
  'callquality.crit.emptyHint': 'Press «Add defaults» to create the criteria from the call-centre quality journal (greeting, language, needs, booking, read-back, prohibited actions…) and adjust their weights.',
  'callquality.crit.edit': 'Call criterion',
  'callquality.crit.key': 'Key (latin)',
  'callquality.crit.titleHint': 'The criterion appears under this name in the AI SIP instruction',
  'callquality.crit.description': 'What to check',
  'callquality.crit.min': 'Minimum',
  'callquality.crit.max': 'Maximum',
  'callquality.crit.weightHint': '0 — informational, not part of the score',
  'callquality.crit.values': 'Possible values (comma-separated)',
  'callquality.crit.goodValue': 'Passing value',
  'callquality.crit.condition': 'Evaluate only when',
  'callquality.crit.aisipNames': 'Other names in AI SIP analyses (comma-separated)',
  'callquality.crit.criticalLabel': 'Failing it is a critical error of the call',
  'callquality.crit.active': 'Active',
  'callquality.crit.confirmed': 'Confirmed by the owner',
  'callquality.ins.title': 'AI SIP instruction',
  'callquality.ins.hint': 'The clinic criteria go to AI SIP as a new draft of the analysis instruction. Bridge never publishes or activates it: test the draft in AI SIP, then publish and activate it there.',
  'callquality.ins.publish': 'Send to AI SIP',
  'callquality.ins.publishTitle': 'Create an instruction draft in AI SIP?',
  'callquality.ins.publishDesc': 'Needs a READ_WRITE token in the AI SIP connector. The current instruction does not change until you activate the draft.',
  'callquality.ins.json': 'JSON for import',
  'callquality.ins.markdown': 'Text for manual entry',
  'callquality.ins.standalone': 'Without the current AI SIP instruction',
  'callquality.ins.history': 'Recent exports',
  'callquality.ins.none': 'The criteria have not been sent to AI SIP yet',
  'callquality.ins.mode.import': 'draft in AI SIP',
  'callquality.ins.mode.document': 'file downloaded',
  'callquality.ins.failed': 'failed',
  'callquality.route.complaint': 'Complaint (incident)',
  'callquality.route.followup': 'Follow-up call',
  'callquality.route.publish': 'Review request',
  'callquality.route.none': 'No action',
  'callquality.route.unrouted': 'Not routed',
  'callquality.rev.rules': 'Score up to {c} — complaint, up to {f} — follow-up call, from {p} — ask for a Google or Instagram review (never posted automatically).',
  'callquality.rev.rulesNoPublish': 'Score up to {c} — complaint, up to {f} — follow-up call; public review requests are off.',
  'callquality.rev.auto': 'New ratings are routed automatically',
  'callquality.rev.manual': 'Automatic routing is off — route by hand',
  'callquality.rev.run': 'Route new',
  'callquality.rev.ran': 'Routed: complaints {c}, follow-ups {f}, requests {p}',
  'callquality.rev.status': 'Status',
  'callquality.rev.status.todo': 'To do',
  'callquality.rev.status.unrouted': 'Not routed',
  'callquality.rev.status.open': 'In progress',
  'callquality.rev.status.done': 'Done',
  'callquality.rev.status.dismissed': 'Dismissed',
  'callquality.rev.status.all': 'All',
  'callquality.rev.anyRoute': 'Any route',
  'callquality.rev.col.at': 'When',
  'callquality.rev.col.score': 'Score',
  'callquality.rev.col.client': 'Client and doctor',
  'callquality.rev.col.comment': 'Review',
  'callquality.rev.col.route': 'Route',
  'callquality.rev.suggested': 'suggested: {r}',
  'callquality.rev.incident': 'Incident #{n}',
  'callquality.rev.inquiry': 'Inquiry #{n}',
  'callquality.rev.task': 'Task: {s}',
  'callquality.rev.routeBtn': 'Route',
  'callquality.rev.done': 'Done',
  'callquality.rev.dismiss': 'Dismiss',
  'callquality.rev.closed': 'Review closed',
  'callquality.rev.routeTitle': 'Where to route the review',
  'callquality.rev.note': 'Note',
  'callquality.rev.empty': 'No reviews to handle',
  'callquality.rev.emptyHint': 'Visit ratings from the app, bot and kiosk appear here. Low ones become a complaint or a follow-up call, high ones a request for a public review.',
  'callquality.rev.source.app': 'app',
  'callquality.rev.source.bot': 'bot',
  'callquality.rev.source.kiosk': 'kiosk',
  'callquality.kpi.title': 'Call-centre KPI',
  'callquality.kpi.subtitle': 'Calls, answer rate, booking conversion, callbacks within SLA, inquiries by channel and client satisfaction',
  'callquality.kpi.inbound': 'Inbound',
  'callquality.kpi.outbound': 'Outbound',
  'callquality.kpi.answered': 'Answered',
  'callquality.kpi.missed': 'Missed',
  'callquality.kpi.answerRate': 'Answer rate',
  'callquality.kpi.avgWait': 'Time to answer',
  'callquality.kpi.avgHandle': 'Handling time',
  'callquality.kpi.fcr': 'First-call resolution',
  'callquality.kpi.fcrSub': 'repeat within 24 h: {v}',
  'callquality.kpi.conversion': 'Call → appointment',
  'callquality.kpi.bookedN': 'booked: {n}',
  'callquality.kpi.callback': 'Called back in time',
  'callquality.kpi.callbackSub': '{n} of {m} missed',
  'callquality.kpi.breaches': 'SLA breaches',
  'callquality.kpi.breachesSub': 'of {n} inquiries',
  'callquality.kpi.csat': 'Client rating',
  'callquality.kpi.csatSub': '{n} ratings · 4–5: {p}',
  'callquality.kpi.quality': 'Call quality',
  'callquality.kpi.byDay': 'Calls by day',
  'callquality.kpi.byHour': 'Inbound by hour',
  'callquality.kpi.channels': 'Inquiries by channel',
  'callquality.kpi.col.channel': 'Channel',
  'callquality.kpi.col.total': 'Total',
  'callquality.kpi.col.open': 'Open',
  'callquality.kpi.col.booked': 'Booked',
  'callquality.kpi.col.lost': 'Lost',
  'callquality.kpi.col.breaches': 'SLA breaches',
  'callquality.kpi.byOperator': 'Operators',
  'callquality.kpi.col.answered': 'Calls',
  'callquality.kpi.col.talk': 'Talk time',
  'callquality.kpi.col.avg': 'Average',
  'callquality.kpi.col.conversion': 'Conversion',
  'callquality.kpi.col.quality': 'Quality',
  'callquality.kpi.empty': 'No calls in the period',
  'callquality.kpi.emptyHint': 'Calls come from AI SIP. Check the AI SIP connector in «Admin → Connectors» or pick another period.',
}
